import React, { FC } from "react";
import { Dropdown } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { useLayerAttributeOptions } from "../../../hooks/attributes/useLayerAttributeOptions";

import { ConditionAttributeProps } from "../types";

export const ConditionAttribute: FC<ConditionAttributeProps> = ({ attribute, changeAttribute, layerName }) => {
  const { t } = useTranslation("layerFilter");
  const attributeOptions = useLayerAttributeOptions(layerName, { withDefault: true });

  return (
    <Dropdown
      label={t("attribute")}
      options={attributeOptions}
      value={attribute || undefined}
      menuWidth={"auto"}
      width="100%"
      onChange={changeAttribute}
      placeholder={attribute || t("notChosen")}
      zIndex={120}
    />
  );
};
